import Dropzone from "dropzone";
import { register } from "../app";

Dropzone.autoDiscover = false;

const loadingClass = "has-warning";
const errorClass = "has-error";

type TemporaryFile = {
    id: string;
    label: string;
};

type TemporaryMessages = {
    default: string;
    release: string;
    uploading: string;
    canceled: string;
};

register(container => {
    container.querySelectorAll<HTMLElement>(".temporary-uploader[data-url][data-messages]").forEach(el => {
        const input = el.querySelector<HTMLInputElement>("input")!;
        const shadow = el.querySelector<HTMLElement>(".temporary-uploader-shadow")!;
        const fake = shadow.querySelector<HTMLElement>(".form-control")!;
        const buttonGroup = shadow.querySelector<HTMLElement>(".btn.btn-danger")!;

        if (input.disabled) {
            fake.classList.add("disabled");

            return;
        }

        // messages
        const messages: TemporaryMessages = JSON.parse(el.dataset.messages!);
        const messageDefault = messages.default;
        const messageRelease = messages.release;
        const messageUploading = messages.uploading;
        const messageCanceled = messages.canceled;

        // functions
        const startLoading = () => el.classList.add(loadingClass);
        const stopLoading = () => el.classList.remove(loadingClass);
        const isLoading = () => el.classList.contains(loadingClass);
        const setMessage = (message: string) => {
            fake.textContent = message;
        };
        const resetMessage = () => setMessage(messageDefault);
        const setError = (message: string) => {
            setMessage(message);
            el.classList.add(errorClass);
        };
        const resetError = () => {
            resetMessage();
            el.classList.remove(errorClass);
        };
        const setFile = (file: TemporaryFile) => {
            stopLoading();
            resetMessage();
            input.value = file.id;
            setMessage(file.label);
            buttonGroup.style.display = "";
        };
        const resetFile = () => {
            input.value = "";
            resetMessage();
            buttonGroup.style.display = "none";
        };

        // start dropzone
        new Dropzone(fake, {
            url: el.dataset.url!,
            paramName: "temporary",
            uploadMultiple: false,
            clickable: true,
            createImageThumbnails: false,
            acceptedFiles: el.dataset.acceptedFiles || "application/pdf",
            timeout: 0,
            dragenter: () => {
                resetError();
                setMessage(messageRelease);
            },
            dragleave: () => {
                resetMessage();
            },
            sending: () => {
                resetError();
                resetFile();
                startLoading();
            },
            uploadprogress: (_file, progress) => {
                setMessage(`${messageUploading} : ${Math.round(progress)}%`);
            },
            success: ((_file: unknown, response: unknown) => {
                setFile(response as TemporaryFile);
            }) as (file: Dropzone.DropzoneFile) => void,
            canceled: () => {
                stopLoading();
                resetMessage();
                setError(messageCanceled);
            },
            error: ((_file: unknown, errorMessage: unknown) => {
                stopLoading();
                resetMessage();
                setError((errorMessage as { error: string }).error);
            }) as (file: Dropzone.DropzoneFile) => void,
        });

        // disable form submit when file is loading
        input.closest("form")!.addEventListener("submit", e => {
            if (isLoading()) {
                e.preventDefault();
            }
        });

        // reset file on button click
        buttonGroup.addEventListener("click", e => {
            if ((e.target as HTMLElement).closest("button")) {
                resetFile();
            }
        });
    });
});
